const PAGE_LOADER_CLASS = "page-loader-spinner"


// ─── Show The Page Loader ───────────────────────────────────────────────────────
export function showPageLoader(title = "", secondary = ""){
    
    var loaderDiv = document.createElement("div")
        loaderDiv.innerHTML = `
            <div class="spinner-content">
                <div class="spinner-border"></div>
                <h4 style="margin-top: 2px;">${title}</h4>
                <div>${secondary}</div>
            </div>
        `
        loaderDiv.setAttribute("class", PAGE_LOADER_CLASS);
    
    document.getElementsByTagName("body")[0].appendChild(loaderDiv);
}


// ─── Remove The Page Loader ─────────────────────────────────────────────────────
export function hidePageLoader(){
    
    var loaderDivs = document.getElementsByClassName(PAGE_LOADER_CLASS)
    if(loaderDivs.length > 0){
        loaderDivs[0].remove()
    }
    
}